import { Component, Vue } from "vue-property-decorator";
import { CreateElement, VNode } from "vue";
import axios from "@/api/AuthAPI/auth-request-api";

import { orders as orderConfig } from "@/config/tab-nav/orders/order-servers.json";
import { AxiosError, AxiosResponse, AxiosRequestConfig } from "axios";
import { IOrder } from "@/@types/orders/new-order";
import { order } from "@/config/host.config";

interface IOrderState {
  menu: Array<IOrder>;
  excursion: Array<IOrder>;
  gallery: Array<IOrder>;
}

@Component({
  name: "orders",
  render: function (createElement: CreateElement): VNode {
    return createElement("div");
  },
})
export default class Orders extends Vue {
  orderInterval: ReturnType<typeof setInterval> | undefined;
  audio = require("@/assets/flute.mp3");

  startCreateExchList(): void {
    this.getExcurionOrders()
      .then((orders: Array<IOrder>) => {
        this.writeOrders(orders);
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  async getExcurionOrders(): Promise<Array<IOrder>> {
    const url = order.mainAPI;
    const config: AxiosRequestConfig = {
      params: {
        "match[show]": true,
        "match[status]": "new",
      },
    };
    return new Promise<Array<IOrder>>((res, rej) => {
      axios
        .get(url, config)
        .then((orders: AxiosResponse<Array<IOrder>>) => {
          if (orders.status === 200) res(orders.data);
        })
        .catch((e: AxiosError) => {
          console.log(e);
          rej(e);
        });
    });
  }

  writeOrders(orders: Array<IOrder>): void {
    const menu = [];
    const excursion = [];
    const gallery = [];
    for (const order of orders) {
      if (order.server_name === orderConfig[0].server) menu.push(order);
      if (order.server_name === orderConfig[1].server) excursion.push(order);
      if (order.server_name === orderConfig[2].server) gallery.push(order);
    }
    const orderList: IOrderState = {
      menu: this.$getRight(orderConfig[0].code) ? menu : [],
      excursion: this.$getRight(orderConfig[1].code) ? excursion : [],
      gallery: this.$getRight(orderConfig[2].code) ? gallery : [],
    };

    this.equalOrders(orderList);
  }

  equalOrders(list: IOrderState): void {
    const countM = list.menu.length - this.$store.getters.getMenuOrders.length;
    const countE =
      list.excursion.length - this.$store.getters.getExcursionOrders;
    const countG = list.gallery.length - this.$store.getters.getGalleryOrders;

    let text = "";
    if (countM > 0)
      text += `<p>${String(this.$i18n.t(`Orders.new.menu`))} ${countM}</>`;
    if (countE > 0)
      text += `<p>${String(this.$i18n.t(`Orders.new.excursion`))} ${countE}</>`;
    if (countG > 0)
      text += `<p>${String(this.$i18n.t(`Orders.new.gallery`))} ${countG}</>`;
    if (text) {
      this.$notify({
        group: "global",
        title: String(this.$i18n.t("Orders.new.text")),
        text,
        type: "success",
        duration: this.$second(300),
      });
      const audio = new Audio(this.audio);
      audio.play();
    }
    this.$store.dispatch("updateNewOrders", list);
  }

  mounted(): void {
    this.startCreateExchList();
    this.orderInterval = setInterval(() => {
      this.startCreateExchList();
    }, this.$second(5));
  }

  destroyed(): void {
    clearInterval(this.orderInterval);
  }
}
